/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useTranslation } from 'react-i18next'
import { Table } from '@dataplace.ai/ui-components/organisms'
import React from 'react'
import { generateSimilarityContent } from '../utils/functions'
import { SimilarLocation } from '../@types/IChainBenchmark'
import { Description, SimilarAdressWrapper, Title } from '../ChainBenchmark.styles'

interface ISimilarAdresses {
  similarLocations: SimilarLocation[];
}

function SimilarAddresses({ similarLocations }: ISimilarAdresses) {
  const { t } = useTranslation()

  const similarityContent = generateSimilarityContent(similarLocations)

  return (
    <SimilarAdressWrapper>
      <Title $borderTop>
        {t('placeme.potential_within_chain.similar')}
      </Title>
      <Description>
        {t('placeme.chain_benchmark.similar.description')}
      </Description>
      <Table
        buildings
        content={similarityContent}
        gap='1rem'
        headerTemplate='0.25fr 6fr'
        labels={[
          '',
          t('placeme.potential_within_chain.similar.label1'),
        ]}
        margin='15px 0 0 0'
        rowTemplate='0.25fr 6fr'
        textLeftIndex={2}
      />
    </SimilarAdressWrapper>
  )
}

export default SimilarAddresses
